var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"board rounded-10 w-full",class:[
    _vm.boardClass,
    {
      'is-test-play': _vm.testPlay,
    } ],style:(_vm.boardStyle)})}
var staticRenderFns = []

export { render, staticRenderFns }